module.exports = __webpack_public_path__ + "static/fonts/UniversLTStd-Bold.d854100.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/UniversLTStd-Bold.otf
// module id = G0X8
// module chunks = 1